import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Components
import Navbar from "./component/Navbar";
import Footer from "./component/Footer";
import FloatingIcon from "./component/FloatingIcon";
import Contact from "./component/Contact";
import Demo from "./component/Demo";
import Home from "./component/Home";
import Aboutus from "./component/Aboutus";
import ImageSlider from "./component/Imageslider";


function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aboutus" element={<Aboutus />} />
          <Route path="/imageslider" element={<ImageSlider />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/contact" element={<Contact />} />
         
        
        </Routes>

        <Footer />
        <FloatingIcon />
      </div>
    </BrowserRouter>
  );
}

export default App;
